import { createStore, combineReducers } from 'redux'
import loginReducer from './reducers/loginReducer'
import accountsReducer from './reducers/accountsReducer'

const initialState = {
  sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(
  combineReducers({
    loginProcess: loginReducer,
    sidebar: changeState,
    accountsProcess: accountsReducer,
  }),
)
export default store
